import {
    ADD_LANDLORD, UPDATE_LANDLORD, DELETE_LANDLORD,
    FETCH_LANDLORDS
} from '../../actions/actionTypes';

const addLandlordReducer = (landlords, payload) => {
    let newLandlords = { ...landlords};
    newLandlords[payload.landlordId] = {
        ...payload
    };
    return newLandlords;   
}

const updateLandlordReducer = (landlords, payload) => {
    let newLandlords = {...landlords};
    newLandlords[payload.landlordId] = { ...payload };
    return newLandlords;

}

const deleteLandlordReducer = (landlords, payload) => {
    let newLandlords = {...landlords};
    delete newLandlords[payload.landlordId];
    return newLandlords;
}

const landlordsReducer = (state={}, action) => {
    let  landlords = state;
    if (action.errors == null){
        switch(action.type){
            case FETCH_LANDLORDS:
                return action.payload.landlords;
            case ADD_LANDLORD:
                return addLandlordReducer(landlords, action.payload);
            case UPDATE_LANDLORD:
                return updateLandlordReducer(landlords, action.payload);
            case DELETE_LANDLORD:
                return deleteLandlordReducer(landlords, action.payload);
            default:
                return landlords;
        }
    }else{
        return landlords;
    }
};
export default landlordsReducer;